import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      // Extract session_id from URL hash
      const hash = location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (sessionId) {
        try {
          const user = await handleGoogleCallback(sessionId);
          
          // Redirect based on role
          switch (user.role) {
            case 'super_admin':
            case 'admin':
              navigate('/admin', { replace: true, state: { user } });
              break;
            case 'curator':
              navigate('/curator', { replace: true, state: { user } });
              break;
            case 'artist':
              navigate('/artist', { replace: true, state: { user } });
              break;
            case 'model':
              navigate('/model', { replace: true, state: { user } });
              break;
            case 'venue_owner':
              navigate('/venue', { replace: true, state: { user } });
              break;
            default:
              navigate('/', { replace: true, state: { user } });
          }
        } catch (error) {
          console.error('Auth callback error:', error);
          navigate('/login', { replace: true });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processCallback();
  }, [location, handleGoogleCallback, navigate]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white/60">Autenticando...</p>
      </div>
    </div>
  );
}
